export const NO_DATA = 'no_data';
export const WEBSITES_DATA_FILENAME = 'websites.data.json';
export const CHECKBOX_STATES = {
  ignore: 'ignore',
  include: 'include',
  exclude: 'exclude',
};
export const EXCLUSION_PREFIX = '!';
export const PER_PAGE_VALUES = [25, 50, 100];
export const DEFAULT_PER_PAGE = 25;
export const DEFAULT_CURRENT_PAGE = 1;
